module.exports = __webpack_public_path__ + "static/media/book.01cf12db.png";